import { useRuntimeVariables } from 'app-kit'
import { useGeckoAuth } from 'features/auth'
import type { DocChatFeedbackSaved } from 'features/knowledgeDocumentViewer/components/advancedSearch/utils/docChatFeedback'
import {
  submitDocChatFeedback,
  type SubmitDocChatFeedbackInput,
} from 'features/knowledgeDocumentViewer/components/advancedSearch/utils/submitDocChatFeedback'
import { useCallback } from 'react'

export type DocChatFeedbackSubmission = Omit<
  SubmitDocChatFeedbackInput,
  'forecastVersion' | 'url'
>

export function useSubmitDocChatFeedback(): (
  submission: DocChatFeedbackSubmission
) => Promise<DocChatFeedbackSaved> {
  const { authorizedAxios } = useGeckoAuth()
  const { POWER_BACKEND_URL, FORECAST_VERSION } = useRuntimeVariables()

  return useCallback(
    (submission: DocChatFeedbackSubmission) =>
      submitDocChatFeedback(authorizedAxios, POWER_BACKEND_URL, {
        ...submission,
        forecastVersion: FORECAST_VERSION || null,
        url: window.location.href,
      }),
    [FORECAST_VERSION, POWER_BACKEND_URL, authorizedAxios]
  )
}
